<template>
  <section class="statement-section">
    <div class="statement-section__header">
      <div class="statement-section__marker">2</div>
      <div>
        <h3 class="statement-section__title">Документ, удостоверяющий личность и адрес</h3>
        <p class="statement-section__description">
          Реквизиты документа и место регистрации
        </p>
      </div>
    </div>

    <div class="statement-fields">
      <passport-fields v-model="formData.passport" density="compact" :hide-details="false" />

      <address-form
        v-model="formData.registrationAddress"
        :token="$model.dadataToken"
        label="Адрес регистрации"
        hint="Начните заполнять адрес регистрации, чтобы получить подсказку"
        variant="outlined"
        :required="registrationAddressRequired"
      />

      <address-form
        v-model="formData.actualAddress"
        :token="$model.dadataToken"
        label="Адрес фактического проживания"
        hint="Заполните, если фактическое место проживания отличается от адреса регистрации"
        variant="outlined"
      />
    </div>
  </section>
</template>

<script>
import PassportFields from 'moodleDir/procollege/lib/vue/passport.vue'
import AddressForm from 'moodleDir/procollege/lib/vue/address/form.vue'

export default {
  name: 'DocumentSection',
  components: {
    PassportFields,
    AddressForm
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    registrationAddressRequired: {
      type: Boolean,
      default: true
    }
  }
}
</script>
